import lang from './lang';

// URL: https://api.voicebunny.com/languages
// Date: 2015-07-27
// Unset caught linting errors since this JSON is automatically generated.

/* eslint quote-props: 0, comma-dangle: 0 */
const languages = [
  {
    'id': 'afr-za',
    'name': 'Afrikaans - South Africa',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ara',
    'name': 'Arabic',
    'pricingType': 'perWord',
    'rtl': true
  },
  {
    'id': 'aze',
    'name': 'Azeri',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ben',
    'name': 'Bengali',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'bos-ba',
    'name': 'Bosnian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'bul-bg',
    'name': 'Bulgarian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'cat-es',
    'name': 'Catalan',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ceb',
    'name': 'Cebuano',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ces-cz',
    'name': 'Czech',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'cmn-zh',
    'name': 'Chinese - Mandarin',
    'pricingType': 'perCharacter',
    'rtl': 0
  },
  {
    'id': 'cym-gb',
    'name': 'Welsh',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'dan-dk',
    'name': 'Danish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'deu-de',
    'name': 'German - Germany',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'deu-au',
    'name': 'German - Austria',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ell-el',
    'name': 'Greek',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-au',
    'name': 'English - Australia',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-ca',
    'name': 'English - Caribbean',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-ie',
    'name': 'English - Ireland',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-nz',
    'name': 'English - New Zealand',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-sco',
    'name': 'English - Scotland',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-uk',
    'name': 'English - England',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-us',
    'name': 'English - North America',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'eng-za',
    'name': 'English - South Africa',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'fas-ir',
    'name': 'Persian (Farsi)',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'fin-fi',
    'name': 'Finnish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'fle-fl',
    'name': 'Flemish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'fra-ca',
    'name': 'French - Canada',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'fra-fr',
    'name': 'French - Europe',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'gbz',
    'name': 'Dari',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'gle',
    'name': 'Irish - Gaelic',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'hau',
    'name': 'Hausa',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'heb-il',
    'name': 'Hebrew',
    'pricingType': 'perWord',
    'rtl': true
  },
  {
    'id': 'hin-in',
    'name': 'Hindi',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'hrv-hr',
    'name': 'Croatian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'hun-hu',
    'name': 'Hungarian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ibo',
    'name': 'Igbo',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ind-id',
    'name': 'Indonesian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'isl-is',
    'name': 'Icelandic',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ita-it',
    'name': 'Italian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'jav-id',
    'name': 'Javanese',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'jpn-jp',
    'name': 'Japanese',
    'pricingType': 'perCharacter',
    'rtl': 0
  },
  {
    'id': 'khm-kh',
    'name': 'Cambodian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'kor-ko',
    'name': 'Korean',
    'pricingType': 'perCharacter',
    'rtl': 0
  },
  {
    'id': 'kur-ir',
    'name': 'Kurdish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'mar-in',
    'name': 'Marathi',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'mkd-mk',
    'name': 'Macedonian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'nep-np',
    'name': 'Nepali',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'nld-de',
    'name': 'Dutch',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'nor-no',
    'name': 'Norwegian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'pan-in',
    'name': 'Punjabi',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'pol-pl',
    'name': 'Polish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'por-br',
    'name': 'Portuguese - Brazil',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'por-pt',
    'name': 'Portuguese - Portugal',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ron-ro',
    'name': 'Romanian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'rus-ru',
    'name': 'Russian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'slk-sk',
    'name': 'Slovak',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'slv-si',
    'name': 'Slovenian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-ar',
    'name': 'Spanish - Argentina',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-cl',
    'name': 'Spanish - Chile',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-co',
    'name': 'Spanish - Colombia',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-es',
    'name': 'Spanish - Castilian (from Spain)',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-latam',
    'name': 'Spanish - Latin American Neutral',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-mx',
    'name': 'Spanish - Mexico',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-pe',
    'name': 'Spanish - Peru',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-pr',
    'name': 'Spanish - Puerto Rico',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-uy',
    'name': 'Spanish - Uruguay',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'spa-ve',
    'name': 'Spanish - Venezuela',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'srp-rs',
    'name': 'Serbian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'swa-ke',
    'name': 'Swahili',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'swe',
    'name': 'Swedish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'tam-in',
    'name': 'Tamil',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'tel-in',
    'name': 'Telugu',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'tgl-ph',
    'name': 'Tagalog',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'tha-th',
    'name': 'Thai',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'tlh',
    'name': 'Klingon',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'tur-tr',
    'name': 'Turkish',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'ukr-ua',
    'name': 'Ukrainian',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'urd-pk',
    'name': 'Urdu',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'vie-vi',
    'name': 'Vietnamese',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'vlcn',
    'name': 'Vulcan',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'wuu-zh',
    'name': 'Chinese - Wu',
    'pricingType': 'perCharacter',
    'rtl': 0
  },
  {
    'id': 'yor',
    'name': 'Yoruba',
    'pricingType': 'perWord',
    'rtl': 0
  },
  {
    'id': 'yue-zh',
    'name': 'Chinese - Cantonese',
    'pricingType': 'perCharacter',
    'rtl': 0
  },
  {
    'id': 'zsm-my',
    'name': 'Malaysian',
    'pricingType': 'perWord',
    'rtl': 0
  }
];

function buildLocales() {
  const locales = {};
  for (const ln of languages) {
    locales[ln.id] = lang(ln.id, ln.name);
  }
  return locales;
}

function filterLocales() {
  const allLocales = buildLocales();
  const mvpLanguageOptions = ['eng-au', 'eng-uk', 'eng-us', 'fra-ca', 'fra-fr', 'spa-latam', 'spa-mx'];
  const filteredLocales = mvpLanguageOptions.reduce((locales, id) => {
    locales[id] = allLocales[id];
    return locales;
  }, {});
  return filteredLocales;
}
export default {
  allAvailableLocales: buildLocales(),
  filteredLocales: filterLocales(),
};



// WEBPACK FOOTER //
// ./src/config/locales.js